// AddressConfirmation.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Modal from 'react-bootstrap/Modal';
import Stack from '@mui/material/Stack';
import { TiTick } from "react-icons/ti";
import { Button, Flex } from 'antd';
import { Collapse } from 'antd';
import axios from 'axios';
import { BASE_URL } from '../../App';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { LeftCircleOutlined, BackwardOutlined, DownOutlined } from '@ant-design/icons';
import { Card, Col, Row, Form, Radio, Input, Checkbox, Select, Space } from 'antd';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { SelectNormal, SelectSearch, MultipleSelect, SelectNormalS } from '../Reusable/SelectBox';
import Typography from '@material-ui/core/Typography';
import TextArea from 'antd/es/input/TextArea';
import CustomButton from '../Reusable/CustomButton';
import CustomTextField from '../Reusable/Numerictext';
import Swal from 'sweetalert2';
import Switch from '@mui/material/Switch';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { useNavigate } from "react-router-dom";
import { Backdrop, CircularProgress, } from '@mui/material';
import { FaFastBackward } from "react-icons/fa";
import { BsFileEarmarkText } from "react-icons/bs";

const AddressConfirmation = ({ 
  selectedOption, 
  orderType, 
  onPrev, 
  onConfirm, 
  onBack, 
  selectedData, 
  qtyvalue, 
  invoiceTotalValue, 
  invoiceSubtotalValue, 
  filteredLabel, 
  filteredValue, 
  anyLocationChecked,
  uploadedDocuments 
}) => {
  const theme = createTheme();
  const [term, setTerm] = useState([]);
  const [open, setOpen] = useState(false);
  const [scroll, setScroll] = React.useState('paper');
  const [createAddress, setCreateAddress] = useState([]);
  const [scrollableModal, setScrollableModal] = useState(false);
  const [radioValue, setRadioValue] = useState('add1');
  const [specialItemCodeChecked, setSpecialItemCodeChecked] = useState(0);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(0);
  const [refresh, setRefresh] = useState();
  const [paymentModes, setPaymentModes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addresses, setAddresses] = useState([]);
  const [displayedAddresses, setDisplayedAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState([]);
  const [selectState, setSelectState] = useState([]);
  const [bcs, setbcs] = useState(false);
  const [checkedData, setCheckedData] = useState(0);
  const [loading1, setloading1] = React.useState(false);
  const [showDocuments, setShowDocuments] = useState(false); 


  const login_id = localStorage.getItem("LOGIN_ID");
  let navigate = useNavigate();

  // useEffect(()=>{
  // alert(orderType);

  // },[])

  useEffect(() => {
    if (selectedData?.length > 0 && selectedData[0].bcs === "bcs") {
      //setSpecialItemCodeChecked(1);
       if (orderType !== "MPO") {
    setSpecialItemCodeChecked(1); 
  } else {
    setSpecialItemCodeChecked(0); 
  }
      setbcs(true);
    } else {
      setbcs(false);
    }
   
  }, []);
  useEffect(() => {
  console.log("Uploaded Documents in AddressConfirmation:", uploadedDocuments);

  if (uploadedDocuments) {
    Object.entries(uploadedDocuments).forEach(([key, docs]) => {
      console.log("Key:", key.trim());
      console.log("Documents:", docs);
    });
  }
}, [uploadedDocuments]);


  const handleBack = () => {
    onBack({ 
      selectedData, 
      qtyvalue, 
      invoiceTotalValue, 
      invoiceSubtotalValue,
      uploadedDocuments
    });
  }

  const gridStyle = {
    width: '100%',
    textAlign: 'left',
  };

  const { Option } = Select;
  const [formValues, setFormValues] = useState({
    uname: "",
    mobile: "",
    gst: "",
    add: "",
    company: "",
    district: "",
    states: "",
    pincode: "",
    alter: "",
  });
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const numericValue = name === 'mobile' || name === 'pincode' || name === 'alter' ? value.replace(/\D/g, '') : value;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: numericValue,
    }));
  };

//   const handleConfirm = () => {
//     setloading1(true);
//     if (checkedData == 0) {
//       Swal.fire({
//         icon: 'warning',
//         title: 'You must accept the terms & conditions',
//       });
//       setloading1(false);
//       return;
//     }

//     // console.log('data address value', selectedAddress);

//     const data = new FormData();
//     data.append('dealer_code', selectedOption.values.DEALER_CODE);
//     data.append('order_type', orderType);
//     data.append('item_list', JSON.stringify(selectedData));
//     data.append('location_id', selectedAddress);
//     data.append('bill_from_any_location', anyLocationChecked);
//     data.append('special_item', specialItemCodeChecked);
//     data.append('termsacceptance', checkedData);
//     data.append('login_id', login_id);
//     data.append('payment_mode', selectedPaymentMode);
//     data.append('type', 'SubmitOrder');
//     data.append('matsubgroup_desc', filteredLabel);
//     data.append('matsubgroup_code', filteredValue);
//     data.append('bcs_item', bcs ? '1' : '0');
    
    
// if (uploadedDocuments && Object.keys(uploadedDocuments).length > 0) {
//   let docIndex = 0;

//   Object.entries(uploadedDocuments).forEach(([itemCode, docs]) => {
//     Object.entries(docs).forEach(([docType, file]) => {
//       if (file) {
//         data.append(`documents[${docIndex}][itemCode]`, itemCode.trim());
//         data.append(`documents[${docIndex}][docType]`, docType);
//         data.append(`documents[${docIndex}][file]`, file);
//         data.append(`documents[${docIndex}][name]`, file.name);
//         docIndex++;
//       }
//     });
//   });

//   data.append("document_count", docIndex);
// }

    
//     console.log('final data', data);
    
//     let config = {
//       method: 'post',
//       maxBodyLength: Infinity,
//       url: BASE_URL + "/createorder",
//       data: data
//     };
const handleBuildItems = async () => {
  const builtItems = [];

  for (const item of selectedData) {
    // const code = item.MAT_CODE ? item.MAT_CODE.trim() : "";
    // const itemDocs = [];
      const code = item.MAT_CODE ? item.MAT_CODE.trim() : "";
    const itemDocs = [];

    const docEntry = uploadedDocuments?.[code] 
      || uploadedDocuments?.[Object.keys(uploadedDocuments || {}).find(k => k.trim() === code)];

    if (docEntry) {
      for (const [docType, file] of Object.entries(docEntry)) {
        if (file && file instanceof File) {
         // alert('Found file for docType: ' + docType);

          const base64Content = await new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onloadend = () => {
              if (reader.result) {
                // Strip off `data:<type>;base64,` prefix if present
                const resultStr = reader.result;
                const parts = resultStr.split(',');
                const b64 = parts.length > 1 ? parts[1] : parts[0];
               // alert('Got base64, length: ' + b64.length);
                resolve(b64);
              } else {
                reject(new Error('reader.result is empty'));
              }
            };

            reader.onerror = (e) => {
              reject(e);
            };

            // **Important** to call readAsDataURL
            reader.readAsDataURL(file);
          });

          // If base64Content resolved
          itemDocs.push({
            docType,
            name: file.name,
            fileKey: `${code}_${docType}`,
            content: base64Content
          });
        } else {
          //console.warn('No file or not instance of File for docType: ', docType, file);
        }
      }
    } else {
      ///console.warn(`No documents found for itemCode: ${code}`);
    }

    builtItems.push({
      ...item,
      documents: itemDocs
    });
  }

  console.log('builtItems', builtItems);
  return builtItems;
};

 const handleConfirm = async () => {
  setloading1(true);
  if (checkedData == 0) {
    Swal.fire({
      icon: 'warning',
      title: 'You must accept the terms & conditions',
    });
    setloading1(false);
    return;
  }

  const data = new FormData();
  const itemsWithDocs = await handleBuildItems(); 
  

  data.append('item_list', JSON.stringify(itemsWithDocs));

  
  for (const item of selectedData) {
    const code = item.MAT_CODE ? item.MAT_CODE.trim() : "";
    const docEntry = uploadedDocuments?.[code] 
      || uploadedDocuments?.[Object.keys(uploadedDocuments || {}).find(k => k.trim() === code)];
    if (docEntry) {
      for (const [docType, file] of Object.entries(docEntry)) {
        if (file && file instanceof File) {
          data.append(`${code}_${docType}`, file, file.name);
        }
      }
    }
  }

  data.append('dealer_code', selectedOption.values.DEALER_CODE);
  data.append('order_type', orderType);
  data.append('location_id', selectedAddress);
  data.append('bill_from_any_location', anyLocationChecked);
  data.append('special_item', specialItemCodeChecked);
  data.append('termsacceptance', checkedData);
  data.append('login_id', login_id);
  data.append('payment_mode', selectedPaymentMode);
  data.append('type', 'SubmitOrder');
  data.append('matsubgroup_desc', filteredLabel);
  data.append('matsubgroup_code', filteredValue);
  data.append('bcs_item', bcs ? '1' : '0');



  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: BASE_URL + "/createorder",
    data: data
  };
    axios.request(config)
      .then((response) => {
        if (response.data.status_code === 400) {
          if (response.data.text === 'The location id field is required.') {
            Swal.fire({
              icon: 'warning',
              title: 'You must add Delivery Address',
            })
            setloading1(false);
          } else {
            Swal.fire({
              icon: 'warning',
              title: response.data.text,
            })
            setloading1(false);
          }
        } else {
          if (anyLocationChecked == 1 && !bcs) {
            const res = response.data;
            let htmlContent = '';

            if (res.success && res.success.length > 0) {
              res.success.forEach(item => {
                htmlContent += `<li>Primary Unit: ${item.UNIT} - Order No: ${item.DOC_NO} - Ref# SAP No: ${item.MESSAGE.replace("Order Created Successfully ", "")}</li>`;
              });
              htmlContent += `</ul>`;
            }

            if (res.failed && res.failed.length > 0) {
              htmlContent += `<h3 style="color:red;">Failed Orders</h3><ul>`;
              res.failed.forEach(item => {
                htmlContent += `<li>Primary Unit: ${item.UNIT} - ${item.MESSAGE}</li>`;
              });
              htmlContent += `</ul>`;
            }

            Swal.fire({
              html: htmlContent,
              icon: res.failed && res.failed.length > 0 ? 'warning' : 'success',
              confirmButtonText: 'OK'
            }).then(() => {
              onPrev();
            });
          } else {
            Swal.fire({
              icon: 'success',
              title: response.data.text_message,
              html: `<b><p>Order No   :  ${response.data.DOC_NO}</p>${!bcs ? `<p>Ref# SAP No : ${response.data.text_number}</p>` : ''}</b>`,
            }).then(() => {
              onPrev();
            });
          }
          setloading1(false);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: 'warning',
          title: error.response.data.message,
        });
        setloading1(false);
        console.log(error);
      });
  };

  const handleSpecialItemCodeChange = () => {
    const newValue = !specialItemCodeChecked;
    const newdata = newValue ? 1 : 0;
    setSpecialItemCodeChecked(newdata);
  };

  const onFinish = (values) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
    const checkeddata = e.target.checked ? 1 : 0;
    setCheckedData(checkeddata);
    console.log('checked data', checkedData);
  };

  const onChange1 = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  const State_Type = selectState ? selectState.map((stateMode) => ({
    Value: stateMode.name,
    Label: stateMode.name,
  })) : [];

  const onClosed = () => {
    setScrollableModal(false);
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + "/saleordertermsandcondition",
          {
            DOCTYPE_CODE: orderType,
          },
          {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('Token'),
            },
          }
        );

        setTerm(response.data.Terms);
      } catch (error) {
        console.error('Error fetching terms:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (displayedAddresses.length >= 1) {
      if (!selectedAddress || displayedAddresses.length > 0) {
        const firstAddressId = displayedAddresses[0].LocationID;
        handleRadioChange({ target: { value: firstAddressId } });
      }
    }
  }, [displayedAddresses]);

  const handleRadioChange = (e) => {
    setSelectedAddress(e.target.value);
  };

  useEffect(() => {
    axios.post(BASE_URL + "/paymenttypelist")
      .then(response => {
        const modes = response.data.PAYMENT_MODE.map(mode => mode.description);
        setPaymentModes(modes);
        if (!selectedPaymentMode && modes.length > 0) {
          setSelectedPaymentMode(modes[0]);
        }
      })
      .catch(error => {
        console.error('Error fetching payment modes:', error);
      });
  }, [selectedPaymentMode]);

  const handlePaymentModeChange = (event) => {
    setSelectedPaymentMode(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + "/getstatelist",
          {},
          {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('Token'),
            },
          }
        );

        setSelectState(response.data.statelist);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(BASE_URL + "/createaddresslistforordering",
        {
          login_id: login_id,
          dealer_code: selectedOption.values.DEALER_CODE,
          address: formValues.add,
          city: formValues.district,
          state: formValues.states,
          pincode: formValues.pincode,
          contactnumber: formValues.mobile,
          name: formValues.uname,
          gstnumber: formValues.gst,
        },
        {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('Token'),
          },
        }
      );
      setCreateAddress(response.data);
      var status = response.data.status_code;
      if (status === 400) {
        Swal.fire({
          icon: 'warning',
          title: response.data.meassage,
        });
      } else {
        Swal.fire({
          icon: 'success',
          title: response.data.text,
        });
        setRefresh(1);
      }
    } catch (error) {
      console.error('Error submitting form:', error);

      if (error.response && error.response.data && error.response.data.message) {
        const errorMessageList = error.response.data.message;
        const formattedErrorMessage = `<ul>${errorMessageList.map(message => `<li>${message}</li>`).join('')}</ul>`;

        Swal.fire({
          icon: "warning",
          title: "Validation Error",
          html: `<div style="text-align: left;">${formattedErrorMessage}</div>`
        });
      } else {
        Swal.fire({
          icon: "error",
          text: "Something went wrong!"
        });
      }
    }

    onClosed();
  };

  const handleModalClosed = () => {
    setScrollableModal(false);
  };

  const handleChange22 = (value) => {
    setTerm(value);
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setRefresh(0);
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + "/getaddresslistforordering",
          {
            login_id: login_id,
            dealer_code: selectedOption.values.DEALER_CODE,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('Token')}`,
            },
          }
        );

        console.table(response.data.dealeraddresses);

        if (Array.isArray(response.data.dealeraddresses)) {
          setAddresses(response.data.dealeraddresses);
          setDisplayedAddresses(response.data.dealeraddresses.slice(0, 2));
        } else {
          console.error('Invalid data format');
        }
      } catch (error) {
        console.error('Error fetching addresses:', error);
      }
    };
    setFormValues("");
    fetchData();
  }, [refresh]);

  const handleLoadMore = () => {
    const remainingAddresses = addresses.slice(displayedAddresses.length);
    const nextBatch = remainingAddresses.slice(0, 2);
    setDisplayedAddresses([...displayedAddresses, ...nextBatch]);
  };

  // Function to render uploaded documents
  const renderUploadedDocuments = () => {
    if (!uploadedDocuments || uploadedDocuments.length === 0) {
      return <p>No documents uploaded</p>;
    }

    return (
      <div style={{ marginTop: '15px', padding: '10px', border: '1px solid #ddd', borderRadius: '5px' }}>
        <h5 style={{ marginBottom: '10px' }}>Uploaded Documents</h5>
        {uploadedDocuments.map((doc, index) => (
          <div key={index} style={{ 
            display: 'flex', 
            alignItems: 'center', 
            padding: '8px', 
            marginBottom: '8px', 
            backgroundColor: '#f9f9f9',
            borderRadius: '4px'
          }}>
            <BsFileEarmarkText style={{ marginRight: '10px', fontSize: '20px' }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 'bold' }}>{doc.name}</div>
              <div style={{ fontSize: '12px', color: '#666' }}>Type: {doc.type}</div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading1} >
        <CircularProgress color="inherit" />
      </Backdrop>

      <br />
       
      <Row align="middle" style={{marginLeft:'5px'}}>
        <div className='container'>
          <Col>
          </Col>
          <Col>
            <div className='float-right'>
              <h2 style={{ fontWeight: 'bold', color: 'black',textAlign:'center', }}>Additional Details</h2>
            </div>
          </Col>
        </div>
      </Row>
      
      <div className='container'>
        <Dialog open={scrollableModal} setOpen={setScrollableModal} onClosed={handleModalClosed} maxWidth="sm" fullWidth>
          <DialogTitle></DialogTitle>
          <DialogContent>
            <Form onSubmit={handleFormSubmit}>
              <Typography id="modal-modal-description" sx={{ mt: 0 }}>
                <Row gutter={16}>
                  <Col xs={24} lg={12}>
                    <div className="form-group">
                      <CustomTextField
                        name="uname"
                        label="Full Name"
                        value={formValues.uname}
                        onChange={(e) => handleInputChange(e)}
                        required
                        pattern="^[A-Za-z\s]+$"
                      />
                    </div>
                  </Col>
                  <Col xs={24} lg={12}>
                    <div className="col-lg form-group">
                      <CustomTextField
                        name="mobile"
                        label="Mobile Number"
                        value={formValues.mobile}
                        type="tel"
                        onChange={(e) => handleInputChange(e)}
                        required
                        maxLength={10}
                      />
                    </div>
                  </Col>
                </Row>
              </Typography>
              
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <Row gutter={16}>
                  <Col xs={24} lg={24}>
                    <div className="col-lg form-group">
                      <TextArea
                        rows={2}
                        style={{ fontSize: 20 }}
                        label={'Address'}
                        id="add"
                        placeholder='Enter Full Address'
                        variant="outlined"
                        name="add"
                        value={formValues.add}
                        onChange={(e) => handleInputChange(e)}
                        required={true}
                      />
                    </div>
                  </Col>
                </Row>
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 0 }}>
                <Row gutter={16}>
                  <Col xs={24} lg={12}>
                    <div className="form-group">
                      <CustomTextField
                        name="gst"
                        label="GST No"
                        value={formValues.gst}
                        onChange={(e) => handleInputChange(e)}
                        maxLength={15}
                        required={true}
                      />
                    </div>
                  </Col>
                  <Col xs={24} lg={12}>
                    <div className="col-lg form-group">
                      <CustomTextField
                        name="company"
                        label="Company Name"
                        value={formValues.company}
                        onChange={(e) => handleInputChange(e)}
                      />
                    </div>
                  </Col>
                </Row>
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 0 }}>
                <Row gutter={16}>
                  <Col xs={24} lg={12}>
                    <div className="form-group">
                      <CustomTextField
                        name="district"
                        label="District"
                        value={formValues.district}
                        onChange={(e) => handleInputChange(e)}
                        required={true}

                      />
                    </div>
                  </Col>
                  <Col xs={24} lg={12}>
                    <div className="col-lg form-group">
                      <SelectNormal
                        label="Select State"
                        options={State_Type}
                        value={formValues.states}
                        //  onChange={(e) => handleInputChange(e)} 
                        onChange={(e) => setFormValues({ ...formValues, states: e.target.value })}

                      />
                    </div>
                  </Col>
                </Row>
              </Typography>

              <Typography id="modal-modal-description" sx={{ mt: 0 }}>
                <Row gutter={16}>
                  <Col xs={24} lg={12}>
                    <div className="form-group">
                      <CustomTextField
                        name="pincode"
                        label="Pincode"
                        value={formValues.pincode}
                        onChange={(e) => handleInputChange(e)}
                        required={true}
                        maxLength={6}

                      />
                    </div>
                  </Col>
                  <Col xs={24} lg={12}>
                    <div className="col-lg form-group">
                      <CustomTextField
                        name="alter"
                        label="Alternate Number"
                        value={formValues.alter}
                        onChange={(e) => handleInputChange(e)}
                        maxLength={10}
                      />
                    </div>
                  </Col>
                </Row>
              </Typography>
			  
              <br></br>
			  
              <center>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                      <CustomButton
                        label="Save"
                        onClick={handleFormSubmit}
                        variant="outlined"
                        size="medium"
                        height={40}
                        width="200px"
                        borderRadius="8px"
                        type="submit"
                        sx={{ flexGrow: 1 }}
                      />

                      <CustomButton
                        label="Cancel"
                        onClick={handleModalClosed}
                        variant="outlined"
                        size="medium"
                        height={40}
                        width="200px"
                        borderRadius="8px"
                        type="submit"
                        sx={{ flexGrow: 1 }}
                        color="error"
                      />
                    </Stack>
                    <br />
                  </div>
                </Typography>
              </center>
            </Form>
          </DialogContent>
        </Dialog>

        <br></br>
        
        {/* Document Section */}
        {uploadedDocuments && uploadedDocuments.length > 0 && (
          <div className="row" style={{ marginBottom: '20px' }}>
            <div className="col-md-10 shadow-sm p-3">
              <div className="d-flex justify-content-between align-items-center">
                <h5>Uploaded Documents</h5>
                <Button 
                  type="link" 
                  onClick={() => setShowDocuments(!showDocuments)}
                  icon={<DownOutlined rotate={showDocuments ? 180 : 0} />}
                >
                  {showDocuments ? 'Hide Documents' : 'Show Documents'}
                </Button>
              </div>
              
              {showDocuments && (
                <div style={{ marginTop: '15px' }}>
                  {uploadedDocuments.map((doc, index) => (
                    <Card 
                      key={index} 
                      style={{ marginBottom: '10px', border: '1px solid #ddd' }}
                      bodyStyle={{ padding: '12px' }}
                    >
                      <div className="d-flex align-items-center">
                        <BsFileEarmarkText style={{ fontSize: '24px', marginRight: '12px', color: '#0d6efd' }} />
                        <div className="flex-grow-1">
                          <h6 style={{ margin: 0 }}>{doc.name}</h6>
                          <small className="text-muted">Type: {doc.type}</small>
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-md-8 shadow-none p-3 bg-primary d-flex justify-content-between">
            <div className='text-left'>
              <h5 className='text-white'><b>Delivery Address</b></h5>
            </div>
            <div>
              <Row>
                <Col style={{ marginLeft: '40px' }}>
                  <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <Button onClick={() => setScrollableModal(!scrollableModal)}>
                      <h5 style={{color:'#0e098f'}}>+Add New Address</h5>
                    </Button>
                  </ThemeProvider>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        
        <div className="row">
          <div className="col-md-10 shadow-sm p-3">
            {displayedAddresses.map(({ LocationID, Address1, City, State, PinCode, ContactNumber, GSTNumber }, index) => (
              <Row key={LocationID}>
                <Col style={{ marginTop: '25px' }}>
                  <Radio
                    value={LocationID}
                    required
                    onChange={handleRadioChange}
                    checked={selectedAddress === LocationID || (index === 0 && !selectedAddress)}
                  />
                </Col>
                <Col span={20}>
                  <Card style={{ ...gridStyle, border: '1px solid #000', marginBottom: '15px', width: '94%' }}>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Row>
                          <Col span={24} style={{ marginBottom: '1px' }}>
                            <div><p>{Address1.toUpperCase()}, {City.toUpperCase()}, {State.toUpperCase()} - <b>{PinCode}</b></p></div>
                            <div><p> GST NO : <b style={{color:'#061c87'}}>{GSTNumber.toUpperCase()}</b>, CONTACT NO : <b style={{color:'#061c87'}}>{ContactNumber}</b></p></div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            ))}
            {addresses.length > displayedAddresses.length && (
              <a onClick={handleLoadMore} style={{ marginLeft: '25px', color:'#0d6efd' }}>
                <DownOutlined /> &nbsp; View All Address
              </a>
            )}
          </div>
        </div>

        <br></br>
        
        <div style={{ marginLeft: '40px' }}>
          <Row>
            <Col>
              <label>Special Item Code</label>
              <Switch
                checked={specialItemCodeChecked}
                onChange={handleSpecialItemCodeChange}
                labelSize="16px"
                disabled={orderType === "MPO"}
              />
            </Col>
          </Row>
        </div>
        
        <br></br>
       
        <div style={{ width: '390px', marginLeft: '38px', height: '10px' }}>
          <Form.Item name="category">
            <div>
              <SelectNormalS
                label=" Select Payment "
                options={paymentModes}
                value={selectedPaymentMode}
                onChange={handlePaymentModeChange}
              />
            </div>
          </Form.Item>
          
          <Row>
            <Col span={2}>
              <Checkbox onChange={onChange}></Checkbox>
            </Col>
            <Col span={20}>
              <a
                style={{ color: '#0d6efd' }}
                name="term"
                onClick={handleClickOpen}
              >
                Terms And Conditions
              </a>
            </Col>
          </Row>
          
          <br />
          
          <Row>
            <Col>
              <ThemeProvider theme={theme}>
                <button 
                  onClick={handleBack}   
                  style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    cursor: 'pointer',
                    color: 'white', 
                    marginRight: '15px', 
                    border: 'none', 
                    background: '#A16BFE', 
                    background: ' -webkit-linear-gradient(to right, #DEB0DF, #A16BFE)',
                    background: 'linear-gradient(to right, #DEB0DF, #A16BFE)', 
                    height: 40 
                  }}
                >
                  <FaFastBackward size={18}/>&nbsp;
                  <span style={{ fontSize: '16px' }}>Previous</span>
                </button>
              </ThemeProvider>
            </Col>
            
            <Col>
              <ThemeProvider theme={theme}>
                <CustomButton
                  style={{ 
                    background: '#ec008c',
                    background: '-webkit-linear-gradient(to right, #fc6767, #ec008c)', 
                    background: 'linear-gradient(to right, #fc6767, #ec008c)',
                    color: '#fff', 
                    border: '2px solid #eee' 
                  }}
                  label="Confirm Order"
                  variant="outlined"
                  color="primary"
                  onClick={handleConfirm}
                  height={40}
                  icon={<TiTick size={30}/>}
                  fontWeight="bold"
                  width="290px"
                  borderRadius="8px"
                />
              </ThemeProvider>
            </Col>
          </Row>
          
          <br></br>
          <br></br>
          
          <Dialog open={open} onClose={handleClose} aria-labelledby="scroll-dialog-title">
            <DialogTitle id="scroll-dialog-title">
              <h6 style={{ fontWeight: 'bold', marginLeft: '23px' }}>Terms And Conditions</h6>
            </DialogTitle>
            
            <DialogContent dividers>
              <DialogContentText>
                <ul style={{ listStyleType: 'disc' }}>
                  {term.map((termItem, index) => (
                    <li key={index} style={{ fontSize: 'smaller' }}>{termItem.TERMS}</li>
                  ))}
                </ul>
              </DialogContentText>
            </DialogContent>
            
            <DialogActions>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div class="text-center">
                  <CustomButton
                    label="Cancel"
                    onClick={handleClose}
                    variant="outlined"
                    color="error"
                    height={40}
                    fontWeight='bold'
                    width='100px'
                    borderRadius="8px"
                    marginRight="20px"
                  />
                </div>
              </ThemeProvider>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default AddressConfirmation;